module.exports = __webpack_public_path__ + "img/BAWS_Hammer1_1_3.e4cd29b2.png";